<template>
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="4"
              >
              <!--Carga al pinchar en ingreso para la obtencion del rol de usuario -->
                <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-alert type="error" v-if="error != ''">
                    <p>{{error}}</p>
                </v-alert>
                <v-card class="elevation-12">
                  <v-toolbar
                    flat
                    class="blue-grey lighten-5"
                  >
                    <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
                    <v-spacer />
                    <v-img src="https://firebasestorage.googleapis.com/v0/b/abonos-ce9dc.appspot.com/o/logo.png?alt=media&token=8bed19df-6f0e-459d-8552-7312e26ea7c4" aspect-ratio="1.7" contain></v-img>
                  </v-toolbar>
                  <v-card-text>
                    <v-form @submit.prevent="ingresoUsuario({email:$v.email.$model, pass:$v.pass.$model})">
                      <v-text-field
                        label="Email"
                        prepend-icon="mdi-account"
                        type="text"
                        v-model="$v.email.$model"
                        :class="{'invalid' : !$v.email.email}"
                      />
                      <v-alert type="error" style="font-size: 12px" dense v-if="!$v.email.email">Email no válido.</v-alert>
                      <v-text-field
                        label="Contraseña"
                        prepend-icon="mdi-key"
                        type="password"
                        v-model="$v.pass.$model"
                      />
                      <v-alert type="error" style="font-size: 12px" dense v-if="!$v.pass.minLength">La contraseña tiene que tener minímo 6 caracteres.</v-alert>
                       <v-card-actions>
                            <v-spacer />
                            <v-btn color="primary" type="submit" :disabled="$v.$invalid">Iniciar Sesión</v-btn>
                        </v-card-actions>
                    </v-form>
                  </v-card-text>
                 
                </v-card>
              </v-col>
            </v-row>
</template>

<script>
import { mapActions,mapState  } from 'vuex';
import { required, email, minLength } from 'vuelidate/lib/validators';
  export default {
    props: {
      source: String,
    },
    data() {
        return {
            email: '',
            pass: '',
        }
    },
    methods: {
        ...mapActions(['ingresoUsuario'])
    },
    computed: {
        ...mapState(['error']),
        desactivar(){
            return this.pass != ''
        },
         overlay: {
          //getter
          get: function () {
            return this.$store.state.cargarRoles
          },
          // setter
          set: function (newVal){
              this.$store.state.cargarRoles = newVal
          }
        }
    },
    validations: {
      email:{required, email},
      pass: {required, minLength: minLength(6)}
    },
    watch: {
      overlay (val) {
        val && setTimeout(() => {
          this.overlay = false
        }, 3000)
      },
    },
  }
</script>